import { Popconfirm, Tooltip } from "antd";
import React from "react";
import { useRTOVoidOrder } from "./store";

function RTOVoidOrder({ order, buttonText }) {
  const { markRTOVoidOrder } = useRTOVoidOrder();
  const handleRTOVoid = () => {
    markRTOVoidOrder(order.order_display_id);
  };
  return (
    <div>
      <Tooltip title="RTO Void Order">
        {order.sub_status !== "RTO Delivered" ? (
          <Popconfirm
            title="Are you sure you want to RTO void this order?"
            placement="topLeft"
            onConfirm={handleRTOVoid}
          >
            <span
              className={`mt-n1 bg-primary text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
              id="rto-void"
            >
              {buttonText}
            </span>
          </Popconfirm>
        ) : (
          <span
            className={`mt-n1 bg-primary disabled-action text-white p-2 rounded-circle d-flex justify-content-center align-items-center shadow`}
          >
            {buttonText}
          </span>
        )}
      </Tooltip>
    </div>
  );
}

export default RTOVoidOrder;
